import { render } from "./FlowQuestionFormItem.vue?vue&type=template&id=82da6b5a"
import script from "./FlowQuestionFormItem.vue?vue&type=script&lang=js"
export * from "./FlowQuestionFormItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__